import {useDispatch, useSelector} from "react-redux";
import {useHistory} from "react-router-dom";
import {
    assetsDialogsSelector,
    certificateAssetsSelector,
    certificateAssetsSettingsSelector,
    cleanCertificates,
    hideExportCsv,
    loadings,
    minMaxLoadedPage,
    openExportCsv,
    openReleaseDialog,
    pageInfoSelector,
    replaceMinMaxLoadedPage,
    selectCertificateAsset,
    setImportCsvDialogAction
} from "../../store/store";
import {useMainTranslation} from "../../../../../newShared/hooks/useMainTranslationHooks/useMainTranslation";
import {TCertificateAsset} from "../../types";
import {PATH_LOCAL_ASSET_MANAGEMENT} from "../../../../../newShared/constants";
import {
    PATH_LOCAL_ASSET_MANAGEMENT_CERTIFICATE_SETTINGS,
    PATH_LOCAL_ASSET_MANAGEMENT_CERTIFICATES,
    PATH_LOCAL_ASSET_MANAGEMENT_CERTIFICATES_ID,
    PATH_LOCAL_ASSET_MANAGEMENT_CERTIFICATES_NEW
} from "../../constants";
import {useSetBreadcrumbs} from "../../../../barsEnvironment/breadcrumbs/hooks/useBreadcrumbs";
import React, {useEffect, useState} from "react";
import {
    exportCsvCertificateAssetsAction,
    getCertificateAssetsAction,
    getCertificateAssetsSettingsAction,
    GetCertificatesAvailableFieldsForExport
} from "../../store/actions";
import {CommonFilterType, minMaxLoadedPageType} from "../../../../../newShared/components/genericTable/types";


export const useCertificateAssetsList = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const {isLoadingList, isLoadingSettings, isLoadingExport, isLoadingFields} = useSelector(loadings);
    const certificateAssets = useSelector(certificateAssetsSelector);
    const _pageInfo = useSelector(pageInfoSelector);
    const {exportCsv: {isOpen, fields}} = useSelector(assetsDialogsSelector);


    const {t: tMenu} = useMainTranslation('', {keyPrefix: 'LeftMenu'});

    useSetBreadcrumbs([
        {
            title: tMenu('Asset Management'),
            path: PATH_LOCAL_ASSET_MANAGEMENT
        },
        {
            title: 'Certificates',
            path: PATH_LOCAL_ASSET_MANAGEMENT_CERTIFICATES
        },
    ]);


    //search and filters
    // const [filter, setFilter] = useState<TCommonAssetsFilter>({
    //     nameLike: '',
    //     prevSearch: '',
    // })


    // const getAssets = (page: number, count: number, _filter: TCommonAssetsFilter, enterDown: boolean) => {
    //     !isLoadingList && dispatch(getCertificateAssetsAction({data: {
    //             page,
    //             count,
    //             filters: {
    //                 nameLike: enterDown && _filter.nameLike ?  [_filter.nameLike] : (!enterDown && _filter.prevSearch ? [_filter.prevSearch] : []),
    //             }}, signal: controller.signal}))
    //     !isLoadingList && setFilter({..._filter, prevSearch: enterDown && _filter.nameLike ? _filter.nameLike  : (!enterDown && _filter.prevSearch ? _filter.prevSearch : '')})
    // }

    const getSettings = (signal?: AbortSignal) => {dispatch(getCertificateAssetsSettingsAction({data: {organizationId: '', workspaceId: ''}, signal}))}

    // const clean = () => dispatch(cleanUp);

    const goToAsset = (asset: TCertificateAsset) => {
        if(asset) {
            dispatch(selectCertificateAsset(asset));
            history.push(`${PATH_LOCAL_ASSET_MANAGEMENT_CERTIFICATES_ID.replace(':id', asset.id)}`);
        }
    }

    useEffect(() => {
        !isLoadingList && getSettings();

        // return () => {
        //     controller.abort();
        //     clean();
        // }
        //eslint-disable-next-line
    }, []);

    const goToAddAsset = () => history.push(PATH_LOCAL_ASSET_MANAGEMENT_CERTIFICATES_NEW);
    const goToSettings = () => history.push(PATH_LOCAL_ASSET_MANAGEMENT_CERTIFICATE_SETTINGS);


    //MENU
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleExportCsv = (fieldKeys: string[]) => {
        handleClose();
        dispatch(exportCsvCertificateAssetsAction({fieldKeys, isDownload: _pageInfo.total < 10000}))
    };

    const handleOpenExportCsv = () => {
        dispatch(openExportCsv());
        dispatch(GetCertificatesAvailableFieldsForExport());
    }

    const handleCloseExportCsv = () => {
        dispatch(hideExportCsv());
    }


    const handleImportCSV = () => {
        handleClose();
        dispatch(setImportCsvDialogAction({isOpen: true}));
    }

    // //filters
    // const setSearch = (search: string) => setFilter({...filter, nameLike: search});
    //
    // const handleCleanSearch = () => {
    //     const newFilter = {...filter, nameLike: '', prevSearch: ''};
    //     setFilter(newFilter);
    //     getAssets(0, DEFAULT_COUNT, newFilter, false);
    // }
    //
    // const handleEnterKey = (e: any) => {
    //     if(e.keyCode === 13){
    //         getAssets(0, DEFAULT_COUNT, filter, true);
    //     }
    // }
    //
    // const handleOnChangeType = (type: string) => {
    //     if (type === 'Any') {
    //         const newFilter = {...filter, type: '' };
    //         setFilter(newFilter);
    //         getAssets(0, DEFAULT_COUNT, newFilter, false);
    //     }
    //     if (type !== 'Any') {
    //         const newFilter = {...filter, type};
    //         setFilter(newFilter);
    //         getAssets(0, DEFAULT_COUNT, newFilter, false);
    //     }
    // }

    const handleOpenRelease = () => {
        dispatch(openReleaseDialog({assetType: 'certificate'}));
        handleClose();
    }

    // pagination
    // const {bottomLoader, onScroll, scrollRef} = useScrollPagination({
    //     getData: ({page, count}) => {
    //         getAssets(
    //             page, count, filter,false
    //         )
    //     },
    //     arrayLength: certificateAssets.length,
    //     isLoading: isLoadingList,
    //     pageInfo: _pageInfo,
    //     cleanData: () => {},
    //
    // })

    const {minLoadedPage, maxLoadedPage} = useSelector(minMaxLoadedPage);

    return {
        settings: useSelector(certificateAssetsSettingsSelector),
        // setSearch,
        // hasMore: _pageInfo.total > ((_pageInfo.page + 1) * _pageInfo.count),
        certificateAssets,
        goToAsset,
        goToAddAsset,
        goToSettings,
        handleOpenExportCsv,
        // exportCsv,
        // importCsv,
        handleImportCSV,
        handleOpenRelease,

        menu: {
            anchorEl,
            handleClose,
            handleClick,
            open,
        },

        exportCsv: {
            isOpen,
            availableFields: fields,
            handleExportCsv,
            handleClose: handleCloseExportCsv,
        },

        // filter: {
        //     filter,
        //     setFilter,
        //     setSearch,
        //     handleEnterKey,
        //     handleCleanSearch,
        //     handleOnChangeType,
        // },

        isLoadingList,
        // isShowingNoAssets: !isLoadingList && certificateAssets.length === 0 && !filter.prevSearch && !filter.type?.length && !filter.nameLike.length,
        isLoadingSettings,
        // handleLoadMore,
        isLoadingExport,
        isLoadingFields,

        // pagination: {
        //     bottomLoader: bottomLoader && certificateAssets.length < _pageInfo.total,
        //     onScroll,
        //     scrollRef
        // },
        genericTable: {
            paging: {
                pageInfo: _pageInfo,
                isLoading: isLoadingList,
                minLoadedPage,
                maxLoadedPage,
                setMinMaxLoadedPage: (data: minMaxLoadedPageType) => dispatch(replaceMinMaxLoadedPage(data)),
                clearRows: () => dispatch(cleanCertificates()),
                fetchPaging: (page: number, count: number, filters: CommonFilterType, search: string) => {
                    dispatch(getCertificateAssetsAction({data: {page, count, filters}}));
                },
            },
        }
    }


}
